import { render, staticRenderFns } from "./BedSensorSettingItem.vue?vue&type=template&id=8ecdbbd0&scoped=true&"
import script from "./BedSensorSettingItem.vue?vue&type=script&lang=js&"
export * from "./BedSensorSettingItem.vue?vue&type=script&lang=js&"
import style0 from "./BedSensorSettingItem.vue?vue&type=style&index=0&id=8ecdbbd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecdbbd0",
  null
  
)

component.options.__file = "BedSensorSettingItem.vue"
export default component.exports